import { Button, Modal } from "antd";
import { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import { Row, Col, Card, Carousel, Typography } from "antd";
//import { fetchGuestHouseStats } from "../../Store/Apis/ReservationApi";
import { FaFacebookF, FaLinkedinIn, FaTwitter, FaGoogle } from "react-icons/fa";
import "./Arrow.css";
import BookNowModal from "./BookNowModal";
import CircularGallery from "./CircularGallery";
import { GiHomeGarage } from "react-icons/gi";
import { MdOutlineDinnerDining } from "react-icons/md";
import { RiHotelLine } from "react-icons/ri";
import { FaPersonSwimming } from "react-icons/fa6";
import { motion } from "framer-motion";

const { Title, Paragraph } = Typography;

// Move the slides array outside the component
const slides = [
  {
    image: "/standard_rooms.jpg",
    title: "Standard Rooms",
    description:
      "Our comfortable, spacious bedrooms have en-suite bathrooms. Our beautiful rooms are equipped with a TV (DSTV), Hair Dryers, Refrigerators, Microwaves, Tea trays, Heaters, Electric Blankets and freshly baked Rusks for your enjoyment. and affordable rooms with all the basic amenities for a relaxing stay.",
  },
  {
    image: "/catering.jpg",
    title: "Self-Catering Units",
    description:
      "We have 3 bright and airy self-catering rooms, each decorated in a modern style. Suited for couples / individuals or those with a small child. A fold out bed for a small child is supplied on request. Our rates are inexpensive to meet your budget. rooms with luxurious furnishings and premium amenities.",
  },
  {
    image: "/lounge.jpg",
    title: "The Lounge",
    description:
      "Elegant suiteOur Guest House has a large lounge where can you enjoy a peaceful evening with other guests. Spend your quiet evenings in the guesthouse lounge and you have the opportunity to meet new people from all walks of life.s with separate living areas and top-notch facilities.",
  },
  {
    image: "/disability_room.jpg",
    title: "Disability Friendly Rooms",
    description:
      "Perfect forOur disability-friendly room has been designed for our physically challenged guests. It is well appointed and has a comfortable King size bed or can be converted into twin single beds. The bathroom is spacious with a wheelchair-friendly shower.  families, offering extra space and kid-friendly amenities.",
  },
];

// Move the AccommodationSlide component outside the main component
const AccommodationSlide = ({ slide, index, onBookNow }) => {
  return (
    <div key={index}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: index * 0.1 }}
      >
        <LuxuryCard
          hoverable
          cover={<img alt={slide.title} src={slide.image} />}
        >
          <CardTitle2 level={4}>{slide.title}</CardTitle2>
          <CardDescription>{slide.description}</CardDescription>
          <BookNowButton onClick={onBookNow}>Book Now</BookNowButton>
        </LuxuryCard>
      </motion.div>
    </div>
  );
};

const GertSibande = () => {
  const [isSticky, setSticky] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [travelDates, setTravelDates] = useState("");
  const [showBookNowModal, setShowBookNowModal] = useState(false);
  const navigate = useNavigate();
  const [activeNavItem, setActiveNavItem] = useState("Home");
  const [currentSlide, setCurrentSlide] = useState(0);
  const [formattedDateString, setFormattedDateString] = useState("");
  const [isCollageOpen, setCollageOpen] = useState(false);
  const [currentCollageIndex, setCurrentCollageIndex] = useState(0);
  const fontStyles = css`
    @import url("https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@500;600;700&family=Montserrat:wght@400;500;600&display=swap");
  `;
  const [isImageViewerOpen, setImageViewerOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: false,
  });

  const heroSlides = [
    {
      image: "/landingpage.jpg",
      heading: "AN OASIS OF AFFORDABLE LUXURY",
      subheading: (
        <span
          style={{
            fontFamily: "Cormorant Garamond, serif",
            color: "white",
            fontStyle: "italic",
          }}
        >
          Welcome to ISIQALO - an ideal base for corporate or leisure travellers
        </span>
      ),
    },
    {
      image: "/landingpage2.jpg", // Use an existing image or add a new one
      heading: "EXPERIENCE COMFORT & ELEGANCE",
      subheading: (
        <span
          style={{
            fontFamily: "Cormorant Garamond, serif",
            color: "white",
            fontStyle: "italic",
          }}
        >
          Unforgettable stays with exceptional service and amenities
        </span>
      ),
    },
  ];

  const galleryItems = [
    { image: "/collage_1.jpg", text: "Dinner" },
    { image: "/collage_2.jpg", text: "Front Gate" },
    { image: "/collage_3.jpg", text: "Breakfast" },
    { image: "/collage_4.jpg", text: "Dining Area" },
    { image: "/collage_5.jpg", text: "Room View" },
    { image: "/collage_6.jpg", text: "Patio" },
    { image: "/collage_7.jpg", text: "Room" },
    { image: "/collage_8.jpg", text: "Exterior View" },
    { image: "/collage_9.jpg", text: "Bath" },
    { image: "/collage_10.jpg", text: "Pool Area" },
  ];

  const openImageViewer = (index) => {
    setCurrentImageIndex(index);
    setImageViewerOpen(true);
  };

  const closeImageViewer = () => {
    setImageViewerOpen(false);
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % galleryItems.length);
  };

  const handlePrevImage = () => {
    setCurrentImageIndex(
      (prevIndex) => (prevIndex - 1 + galleryItems.length) % galleryItems.length
    );
  };

  const openCollage = (index) => {
    setCurrentCollageIndex(index);
    setCollageOpen(true);
  };

  const closeCollage = () => {
    setCollageOpen(false);
  };

  const handleBookNow = () => {
    setShowBookNowModal(true); // Opens the BookNowModal
  };

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > window.innerHeight); // Activate sticky behavior after scrolling past the first section
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 7000);
    return () => clearInterval(interval);
  }, [heroSlides.length]);

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    // Format dates in a tech-style format
    const formatDateTech = (date) => {
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      return `${day}.${month}`;
    };

    // Create the futuristic date string
    const formattedString = `${formatDateTech(today)} > ${formatDateTech(
      tomorrow
    )}`;
    setFormattedDateString(formattedString);
  }, []);

  const goToPage = () => {
    navigate("/login"); // Navigates to the /destination route
  };
  const goToContact = () => {
    navigate("/Contact"); // Navigates to the /destination route
  };

  const goToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" }); // Smooth scroll to the top
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const [stats, setStats] = useState({
    guestsNotFromSA: 0,
    percentNotFromSA: 0,
    breakfastCount: 0,
    googleReviewsCount: 0,
  });

  // useEffect(() => {
  //   const getStats = async () => {
  //     const data = await fetchGuestHouseStats();
  //     if (data) setStats(data);
  //   };

  //   getStats();
  // }, []);

  const carouselSettings = {
    autoplay: true,
    arrows: true,
    infinite: true,
    dots: true,
    speed: 800,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const handleGalleryImageClick = (index) => {
    setCurrentImageIndex(index);
    setImageViewerOpen(true); // Open modal only for gallery images
  };

  // Prevent CircularGallery from re-rendering during ImageViewer navigation
  const shouldCircularGalleryUpdate = !isImageViewerOpen && inView;

  return (
    <MainContainer>
      <StickyNav isSticky={isSticky}>
        <LogoContainer>
          <Logo src="/logo.png" alt="Logo" onClick={goToTop} />
        </LogoContainer>
        <NavItems>
          <NavItem active={activeNavItem === "Home"} onClick={goToTop}>
            Home
          </NavItem>
          <NavItem
            active={activeNavItem === "Contact Us"}
            onClick={goToContact}
          >
            Contact Us
          </NavItem>
          <NavItem active={activeNavItem === "Staff Login"} onClick={goToPage}>
            Staff Login
          </NavItem>
          {isSticky && (
            <NavItem
              active={activeNavItem === "Book Now"}
              onClick={() => {
                setActiveNavItem("Book Now");
                setShowBookNowModal(true);
              }}
            >
              Book Now
            </NavItem>
          )}
        </NavItems>
      </StickyNav>

      {showBookNowModal && (
        <BookNowModal onClose={() => setShowBookNowModal(false)} />
      )}

      <HeroSection>
        {/* Dynamic Hero Slides */}
        {heroSlides.map((slide, index) => (
          <HeroSlide
            key={index}
            bgImage={slide.image}
            active={currentSlide === index}
          />
        ))}

        <HeroContent>
          <MainHeading style={{ color: "white" }}>
            {heroSlides[currentSlide].heading}
          </MainHeading>
          <SubHeading>{heroSlides[currentSlide].subheading}</SubHeading>
          <CTAButtonContainer>
            {/* <CTAButton>
              <AnimatedDateWrapper>
                <DateIconWrapper>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 2V6M16 2V6M3 10H21M7 14H9M12 14H14M17 14H19M7 18H9M12 18H14M17 18H19M5 22H19C20.1046 22 21 21.1046 21 20V8C21 6.89543 20.1046 6 19 6H5C3.89543 6 3 6.89543 3 8V20C3 21.1046 3.89543 22 5 22Z"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </DateIconWrapper>
                <DynamicDateContent>
                  <DateTitle>CHECK-IN/OUT</DateTitle>
                  <DynamicDateValue>{formattedDateString}</DynamicDateValue>
                </DynamicDateContent>
              </AnimatedDateWrapper>
            </CTAButton> */}

            <CTAButton onClick={() => setShowBookNowModal(true)}>
              Make A Reservation
            </CTAButton>

            {/* <CTAButton blue onClick={() => setShowBookNowModal(true)}>
              Check Availability
            </CTAButton> */}
          </CTAButtonContainer>
        </HeroContent>

        {/* Slide Indicators */}
        <SlideIndicators>
          {heroSlides.map((_, index) => (
            <SlideIndicator
              key={index}
              active={currentSlide === index}
              onClick={() => goToSlide(index)}
            />
          ))}
        </SlideIndicators>
      </HeroSection>

      <Section dark>
        <ContentWrapper>
          <TwoColumnLayout>
            <Column>
              <SectionHeading
                style={{
                  fontFamily: "Raleway, sans-serif",
                  color: "#444444",
                  fontSize: "36px",
                  margin: "0px 0px 15px",
                }}
              >
                Welcome To ISIQALO GUESTHOUSE
              </SectionHeading>
            </Column>
            <Divider />
            <Column>
              <SectionText
                style={{
                  fontFamily: "Open Sans, sans-serif",
                  color: "#444444",
                  fontSize: "18px",
                  margin: "0px 0px 15px",
                }}
              >
                Isiqalo Guesthouse is situated in the upper area of Standerton,
                Mpumalanga. This is perfect for those who prefer to enjoy their
                time in the beautiful outdoors. <br />
              </SectionText>
              <SectionText
                style={{
                  fontFamily: "Open Sans, sans-serif",
                  color: "#444444",
                  fontSize: "18px",
                }}
              >
                We offer 17 en-suite bedrooms, one which is a
                disability-friendly room and three self-catering rooms.
                <br />
                We have an ideal garden for special occasions, business
                functions, and conference facilities.
              </SectionText>
            </Column>
          </TwoColumnLayout>
        </ContentWrapper>
      </Section>

      <ParallaxSection imageUrl="/food.jpg">
        <ContentWrapper>
          <SectionHeading
            style={{
              fontFamily: "Montserrat, sans-serif",
              color: "white",
              fontSize: "38px",
              fontWeight: "bold",
              margin: "0px 0px 15px",
              textAlign: "center",
            }}
          >
            We are proud to offer tasteful, locally inspired food.
          </SectionHeading>
          <SectionText
            style={{
              fontFamily: "Open Sans, sans-serif",
              color: "white",
              fontSize: "17px",
              fontWeight: "bold",
              margin: "0px 0px 15px",
              textAlign: "center",
            }}
          >
            A candlelit dinner for day visitors is served upon request, bookings
            are essential. A full continental breakfast as well as a full
            English breakfast is served every morning.
          </SectionText>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <StyledButton onClick={() => setShowBookNowModal(true)}>
              Book Now
            </StyledButton>
          </div>
        </ContentWrapper>
      </ParallaxSection>

      <Section>
        <ContentWrapper>
          <SectionHeading>Our Facilities</SectionHeading>
          <Card>
            <Card.Grid style={{ width: "25%", textAlign: "center" }}>
              <Icon>
                <RiHotelLine size={40} />
              </Icon>
              <CardTitle>Accommodation</CardTitle>
            </Card.Grid>
            <Card.Grid style={{ width: "25%", textAlign: "center" }}>
              <Icon>
                <FaPersonSwimming size={40} />
              </Icon>
              <CardTitle>Swimming Pool</CardTitle>
            </Card.Grid>
            <Card.Grid style={{ width: "25%", textAlign: "center" }}>
              <Icon>
                <MdOutlineDinnerDining size={40} />
              </Icon>
              <CardTitle>Delicious Food</CardTitle>
            </Card.Grid>
            <Card.Grid style={{ width: "25%", textAlign: "center" }}>
              <Icon>
                <GiHomeGarage size={40} />
              </Icon>
              <CardTitle>Free Covered Parking</CardTitle>
            </Card.Grid>
          </Card>
        </ContentWrapper>
      </Section>

      <ImageSection imageUrl="/food.jpg">
        <ContentWrapper>
          <AchievementsLayout>
            <LeftColumn>
              <SectionHeading
                style={{
                  fontFamily: "Raleway, sans-serif",
                  color: "white",
                  fontSize: "29px",
                  fontWeight: "bold",
                  margin: "0px 0px 15px",
                  textAlign: "center",
                }}
              >
                We Are Proud of Our Achievements
              </SectionHeading>
            </LeftColumn>
            <Divider />
            <RightColumn>
              <Achievement>
                <Figure>{stats.googleReviewsCount}</Figure>
                <Subheader
                  style={{
                    fontFamily: "Open Sans, sans-serif",
                    color: "white",
                    fontSize: "20px",
                    fontWeight: "bold",
                    textWrap: "nowrap",
                    margin: "0px 0px 15px",
                    textAlign: "center",
                  }}
                >
                  Good Reviews
                </Subheader>
              </Achievement>
              <Achievement>
                <Figure>{stats.guestsNotFromSA}</Figure>
                <Subheader
                  style={{
                    fontFamily: "Open Sans, sans-serif",
                    color: "white",
                    fontSize: "20px",
                    fontWeight: "bold",
                    textWrap: "nowrap",
                    margin: "0px 0px 15px",
                    textAlign: "center",
                  }}
                >
                  International Guests
                </Subheader>
              </Achievement>
              <Achievement>
                <Figure>{stats.breakfastCount}</Figure>
                <Subheader
                  style={{
                    fontFamily: "Open Sans, sans-serif",
                    color: "white",
                    fontSize: "20px",
                    fontWeight: "bold",
                    textWrap: "nowrap",
                    margin: "0px 0px 15px",
                    textAlign: "center",
                  }}
                >
                  Served Breakfasts
                </Subheader>
              </Achievement>
            </RightColumn>
          </AchievementsLayout>
        </ContentWrapper>
      </ImageSection>

      <StyledSection>
        <ContentWrapper1>
          <SectionHeading1 level={2}>Our Accommodation</SectionHeading1>
          <SectionSubheader1>
            Each of our rooms has its own unique sense of style and design. No
            two rooms are the same, but each was carefully designed with a
            special visual aesthetic in mind. We are confident that you will
            love what you see.
          </SectionSubheader1>

          <StyledCarousel {...carouselSettings}>
            {slides.map((slide, index) => (
              <AccommodationSlide
                key={index}
                slide={slide}
                index={index}
                onBookNow={handleBookNow}
              />
            ))}
          </StyledCarousel>
        </ContentWrapper1>
      </StyledSection>

      <ModernGallerySection ref={ref}>
        <GalleryContentWrapper>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
            transition={{ duration: 0.8 }}
          >
            <GallerySectionHeading style={{ color: "Black" }}>
              Our Gallery
            </GallerySectionHeading>
            <GallerySubheading>
              Explore the beauty and comfort of Isiqalo Guesthouse
            </GallerySubheading>
          </motion.div>

          {/* CircularGallery with conditional rendering */}
          {shouldCircularGalleryUpdate && (
            <CircularGalleryWrapper
              initial={{ opacity: 0 }}
              animate={inView ? { opacity: 1 } : { opacity: 0 }}
              transition={{ duration: 0.8 }}
            >
              <CircularGallery
                items={galleryItems}
                bend={3}
                textColor="black"
                borderRadius={0.05}
                font="bold 24px sans-serif"
                onImageClick={handleGalleryImageClick} // Pass only the index
              />
            </CircularGalleryWrapper>
          )}
        </GalleryContentWrapper>
      </ModernGallerySection>

      {isImageViewerOpen && (
        <ImageViewer>
          <ImageViewerOverlay onClick={closeImageViewer} />
          <CloseViewerButton onClick={closeImageViewer}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M6 6L18 18"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </CloseViewerButton>
          <ImageViewerContent>
            <ArrowButton onClick={handlePrevImage}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 18L9 12L15 6"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </ArrowButton>
            <EnlargedImageContainer>
              <EnlargedImage
                src={galleryItems[currentImageIndex].image}
                alt={`Gallery Image ${currentImageIndex + 1}`}
              />
              <ImageCounter>
                {currentImageIndex + 1} / {galleryItems.length}
              </ImageCounter>
            </EnlargedImageContainer>
            <ArrowButton onClick={handleNextImage}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 18L15 12L9 6"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </ArrowButton>
          </ImageViewerContent>
        </ImageViewer>
      )}

      <GoogleMapSection>
        <MapContainer>
          <iframe
            title="Google Maps"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3454.1234567890123!2d29.4567890123456!3d-26.9334567890123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1eebc1234567890%3A0xabcdef1234567890!2s5A%20Kieser%20St%2C%20Standerton%2C%202430!5e0!3m2!1sen!2sza!4v1234567890123"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </MapContainer>
      </GoogleMapSection>

      <FooterSection>
        <FooterContent>
          <LogoSection>
            <Logo1
              src="/footer_logo.png"
              alt="Isiqalo Guesthouse Logo"
              style={{ width: "260px", height: "51px" }}
            />
            <h3
              style={{
                color: "#d2d2d2",
                font: "Open Sans, sans-serif",
                fontSize: "18px",
              }}
            >
              Guesthouse, Self-catering and Bed and Breakfast
            </h3>
          </LogoSection>

          <QuickLinks>
            <h3
              style={{
                color: "white",
                font: "Montserrat, sans-serif",
                fontSize: "19px",
              }}
            >
              Quick Links
            </h3>
            <StyledLink
              to="/"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              &gt; Home
            </StyledLink>
            <StyledLink onClick={() => setShowBookNowModal(true)}>
              &gt; Book Now
            </StyledLink>
            <StyledLink to="/contact">&gt; Contact Us</StyledLink>
          </QuickLinks>

          <SocialIcons>
            <h3
              style={{
                color: "white",
                font: "Montserrat, sans-serif",
                fontSize: "19px",
              }}
            >
              Follow Us
            </h3>
            <div className="icon-container">
              <a
                href="https://www.facebook.com/IsiqaloGuesthouse/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedinIn />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTwitter />
              </a>
              <a
                href="https://google.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaGoogle />
              </a>
            </div>
          </SocialIcons>

          <ContactSection>
            <h3
              style={{
                color: "white",
                font: "Montserrat, sans-serif",
                fontSize: "19px",
              }}
            >
              Contact Us
            </h3>
            <p>5A Kieser Street, Standerton</p>
            <p>+27 17 714 0039</p>
            <p>info@isiqaloguesthouse.co.za</p>
          </ContactSection>
        </FooterContent>
      </FooterSection>

      <CopyrightSection>
        <p>
          Copyright © Isiqalo {new Date().getFullYear()} All rights reserved.
        </p>
      </CopyrightSection>
    </MainContainer>
  );
};

// Styled Components
const MainContainer = styled.div`
  width: 100%;
  max-width: 100%;
  overflow-x: hidden; /* Prevent horizontal scrolling */
`;

// const StickyNav = styled.nav`
//   display: flex;
//   justify-content: space-between; /* Space between logo and nav items */
//   align-items: center; /* Vertically center items */
//   padding: 1rem 2rem; /* Add padding for spacing */
//   position: fixed; /* Ensure the nav bar stays fixed */
//   top: 0;
//   width: 100%;
//   background: white; /* Set background color to white */
//   transition: all 0.3s ease;
//   z-index: 1000;
//   box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1); /* Always show shadow */
// `;

const LogoContainer = styled.div`
  display: flex;
  align-items: center; /* Align logos vertically */
`;

const Logo = styled.img`
  height: 50px; /* Adjust the height of the logo */
  cursor: pointer;
`;

const Logo2 = styled.img`
  height: 50px; /* Adjust the height of the logo */
  cursor: pointer;
  margin-left: 10px; /* Add a tiny gap between logos */
`;

const NavItems = styled.div`
  display: flex;
  gap: 2rem;
`;

const NavItem = styled.div`
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: 500;
  position: relative;
  padding: 0.5rem 0;
  color: ${(props) => (props.active ? "#a17c1f" : "#333")};
  transition: all 0.3s ease;

  &::after {
    content: "";
    position: absolute;
    width: ${(props) => (props.active ? "100%" : "0")};
    height: 2px;
    bottom: 0;
    left: 0;
    background-color: #a17c1f;
    transition: width 0.3s ease;
  }

  &:hover {
    color: #a17c1f;

    &::after {
      width: 100%;
    }
  }
`;

// Updated StickyNav Component
const StickyNav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  position: fixed;
  top: 0;
  width: 100%;
  background: rgba(
    255,
    255,
    255,
    ${(props) => (props.isSticky ? "0.95" : "0.85")}
  );
  backdrop-filter: blur(8px);
  transition: all 0.3s ease;
  z-index: 1000;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);
`;

// Modern Hero Section with Carousel
const HeroSection = styled.section`
  height: 100vh;
  position: relative;
  overflow: hidden;
`;

const HeroSlide = styled.div`
  height: 100vh;
  width: 100%;
  background-image: url(${(props) => props.bgImage});
  background-position: center;
  background-size: cover;
  font-family: "Cormorant Garamond", serif;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  left: 0;
  opacity: ${(props) => (props.active ? 1 : 0)};
  transition: opacity 1.5s ease-in-out;
`;

const HeroContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 90%;
  max-width: 1200px;
  z-index: 10;
  padding: 2rem;
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(2px);
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
`;

const MainHeading = styled.h1`
  font-size: 4rem;
  letter-spacing: 3px;
  margin-bottom: 1.5rem;
  font-weight: 300;
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 1s forwards;
  animation-delay: 0.3s;

  @keyframes fadeInUp {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 992px) {
    font-size: 3rem;
  }

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }

  @media (max-width: 480px) {
    font-size: 2rem;
  }
`;

const SubHeading = styled.p`
  font-size: 1.5rem;
  margin-bottom: 2rem;
  letter-spacing: 1.5px;
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 1s forwards;
  animation-delay: 0.6s;
`;

// Enhanced CTA Button Container with Modern Design
const CTAButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 12px;
  width: 100%;
  max-width: 1010px;
  margin: 0 auto;
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 1s forwards;
  animation-delay: 0.9s;

  @media (max-width: 991px) {
    flex-direction: column;
    max-width: 450px;
  }
`;

// Enhanced Modern CTA Buttons
const CTAButton = styled.button`
  padding: 0.9rem 1.5rem;
  background-color: ${(props) => (props.blue ? "#084c7c" : "#b99028")};
  color: white;
  font-size: 1.05rem;
  font-weight: 500;
  cursor: pointer;
  border: none;
  border-radius: 12px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
    transition: all 0.6s;
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);

    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(-1px);
  }

  @media (max-width: 1200px) {
    padding: 1rem 1rem;
    font-size: 1rem;
  }
`;

const AnimatedDateWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  gap: 8px;
`;

const DateIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  animation: pulse 2s infinite;

  @keyframes pulse {
    0% {
      opacity: 0.8;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.8;
    }
  }
`;

const DynamicDateContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const DateTitle = styled.div`
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  opacity: 0.9;
`;

const DynamicDateValue = styled.div`
  font-size: 0.95rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  position: relative;

  &:after {
    content: "";
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 100%;
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.8),
      transparent
    );
    animation: scanline 2s infinite;
  }

  @keyframes scanline {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;
const SlideIndicators = styled.div`
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 10;
`;

const SlideIndicator = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${(props) =>
    props.active ? "white" : "rgba(255, 255, 255, 0.5)"};
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.2);
  }
`;

const BoldText = styled.span`
  font-weight: bold;
  //
`;

const StyledButton = styled.button`
  display: inline-block;
  width: 140px;
  padding: 1rem 0.5rem;
  margin: 0.5rem;
  background: transparent;
  border: 2px solid #b99028;

  color: white;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    transform: translateY(-2px);
  }
`;

const BookingModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
`;

const ModalContent = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 8px;
  position: relative;
  max-width: 500px;
  width: 90%;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
`;

const Section = styled.section`
  min-height: ${({ fullHeight }) => (fullHeight ? "100vh" : "auto")};
  padding: ${({ fullHeight }) => (fullHeight ? "0" : "4rem 2rem")};
  background: ${({ dark }) => (dark ? "white" : "#f9f9f9")};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: ${({ fullHeight }) => (fullHeight ? "0" : "3rem 1rem")};
  }
`;

const ContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
`;

const TwoColumnLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;

  @media (max-width: 992px) {
    gap: 1.5rem;
  }
`;

const Column = styled.div`
  flex: 1;
  max-width: 50%;
  text-align: center;

  @media (max-width: 992px) {
    max-width: 100%;
    padding: 0 1rem;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 0;
  }
`;

const Divider = styled.div`
  width: 2px;
  height: auto; /* Change from fixed 250px */
  max-height: 250px; /* Add a maximum height */
  background-color: #dedede;
  margin: 0 1rem;
  align-self: stretch; /* Make it stretch to fill available space */

  @media (max-width: 992px) {
    max-height: 200px; /* Shorter on medium screens */
  }

  @media (max-width: 768px) {
    display: none; /* Already hiding on small screens */
  }
`;
const SectionText = styled.p`
  font-size: 1.2rem; /* Slightly larger font size */
  line-height: 2; /* Increase line height for better spacing */
  color: #665; /* Neutral text color */
  text-align: justify; /* Ensures text spreads evenly */
  text-justify: inter-word; /* Improves justification by adjusting spacing */
  padding: 0 1rem; /* Add padding for better spacing */
`;

const SectionHeading = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #333;
  font-weight: 300;
  text-align: center;
`;

const ParallaxSection = styled(Section)`
  background-image: ${({ imageUrl }) =>
    `url(${imageUrl})`}; /* Background image */
  background-attachment: fixed; /* Parallax effect */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative; /* Ensure the section is positioned relative for layering */

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); /* Dark overlay with 50% opacity */
    z-index: 1; /* Ensure the overlay is above the background image */
  }

  & > * {
    position: relative; /* Ensure content is above the overlay */
    z-index: 2; /* Ensure the content is above the overlay */
    color: white; /* Ensure text color is white */
  }
`;

const StyledCard = styled(Card)`
  text-align: center;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid #eaeaea;

  &:hover {
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }
`;

const Icon = styled.div`
  font-size: 3rem;
  margin-bottom: 1rem;
  color: #333;
`;

const CardTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
`;
const AchievementsLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  margin-top: 2rem;
  padding: 2rem; /* Add padding for spacing */
  width: 100%; /* Ensure it spans the full width */
  box-sizing: border-box; /* Include padding in width calculation */

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1.5rem;
  }
`;

const ImageSection = styled.section`
  height: auto; /* Changed from fixed 50vh */
  min-height: 50vh; /* Added min-height */
  padding: 4rem 2rem;
  background-image: ${({ imageUrl }) => `url(${imageUrl})`};
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;

  display: flex;
  align-items: center; /* Changed from flex-start */
  justify-content: center; /* Changed from flex-start */

  /* Overlay */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1;
  }

  & > * {
    position: relative;
    z-index: 2;
    color: white;
  }

  @media (max-width: 768px) {
    padding: 3rem 1rem;
  }
`;
const LeftColumn = styled.div`
  flex: 1;
`;

const RightColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  gap: 2.5rem;
`;

const Achievement = styled.div`
  text-align: center;
`;

const Figure = styled.h2`
  font-size: 2.5rem;
  font-weight: bold;
  color: #b99028;
`;

const Subheader = styled.p`
  font-size: 1rem;
  color: #555;
`;

const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* Set 4 images per row */
  gap: 1.5rem; /* Add spacing between images */
  margin: 2rem auto; /* Center the grid vertically within the section */
  width: 100%; /* Ensure it spans the full width of the section */
  max-width: 1200px; /* Limit the maximum width */
  padding: 0 1rem; /* Add padding to prevent overflow */
`;

const GalleryImage = styled.img`
  width: 100%;
  height: 300px; /* Set a fixed height for larger images */
  object-fit: cover;
  border-radius: 8px;
  transition: transform 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
  }
`;

const GoogleMapSection = styled.section`
  background-color: black;
  height: 50vh; /* 50% of the screen height */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const MapContainer = styled.div`
  width: 100%;
  height: 100%; /* Fill the section height */
  border: none;
  overflow: hidden;
`;

const ImageViewer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ImageViewerOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 1;
`;

const ImageViewerContent = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// const EnlargedImageContainer = styled.div`
//   position: relative;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
// `;

// const EnlargedImage = styled.img`
//   max-width: 90vw;
//   max-height: 80vh;
//   border-radius: 8px;
//   box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
// `;

// const ArrowButton = styled.button`
//   background: rgba(0, 0, 0, 0.5);
//   border: none;
//   width: 50px;
//   height: 50px;
//   border-radius: 50%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   margin: 0 1rem;
//   cursor: pointer;
//   transition: background 0.3s ease;

//   &:hover {
//     background: rgba(185, 144, 40, 0.8);
//   }
// `;

// const ImageCounter = styled.div`
//   color: white;
//   background: rgba(0, 0, 0, 0.6);
//   padding: 5px 15px;
//   border-radius: 15px;
//   position: absolute;
//   bottom: -30px;
//   font-size: 14px;
// `;

const Logo1 = styled.img`
  width: 180px; // Adjust as needed
  margin-bottom: 10px;
`;

const StyledLink = styled(Link)`
  display: block;
  color: white;
  font-size: 18px;
  text-decoration: none;
  margin: 5px 0;
  transition: color 0.3s ease-in-out;

  &:hover {
    color: #f39c12;
  }
`;

const FooterSection = styled.section`
  background-color: black;
  min-height: 40vh; /* Changed from fixed height to min-height */
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 40px 20px;
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: flex-start; /* Changed from center to flex-start */
  width: 90%; /* Increased from 80% */
  gap: 20px;
  flex-wrap: wrap;

  @media (max-width: 992px) {
    width: 100%;
    justify-content: center;
  }
`;

const LogoSection = styled.div`
  flex: 1;
  min-width: 200px; /* Adjust minimum width */
  display: flex;
  flex-direction: column;
  align-items: center; /* Center-align the content */
  text-align: center; /* Center-align text */
`;

const QuickLinks = styled.div`
  flex: 1;
  min-width: 200px; /* Adjust minimum width */
  text-align: center; /* Center-align text */
`;

const SocialIcons = styled.div`
  flex: 1;
  min-width: 200px; /* Adjust minimum width */
  display: flex;
  flex-direction: column; /* Arrange header and icons vertically */
  align-items: center; /* Center items horizontally */
  gap: 8px; /* Reduce spacing between header and icons */
  margin-top: 10px;

  h3 {
    color: white;
    font-size: 18px; /* Slightly smaller font size */
    font-family: "Montserrat, sans-serif";
    margin: 0; /* Remove default margin */
  }

  .icon-container {
    display: flex;
    flex-direction: row; /* Arrange icons in a row */
    gap: 10px; /* Reduce spacing between icons */
  }

  a {
    color: white;
    font-size: 18px; /* Slightly smaller font size */
    transition: color 0.3s ease-in-out;

    &:hover {
      color: #f39c12;
    }
  }
`;

const ContactSection = styled.div`
  flex: 1;
  min-width: 200px; /* Adjust minimum width */
  text-align: center; /* Center-align text */
`;

const CopyrightSection = styled.div`
  background-color: black;
  border-top: 1px solid #444;
  height: 10vh; /* 10% of the screen height */
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
`;

//Accomodation Styles

const StyledSection = styled.section`
  min-height: 100vh;
  background-color: #f9f6f0;
  padding: 4rem 0;
`;

const ContentWrapper1 = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
`;

const SectionHeading1 = styled(Title)`
  font-family: "Playfair Display", serif;
  font-size: 2.5rem !important;
  text-align: center;
  margin-bottom: 0.5rem !important;
  color: #2c3e50;
`;

const SectionSubheader1 = styled(Paragraph)`
  font-family: "Montserrat", sans-serif;
  font-size: 1.1rem;
  text-align: center;
  max-width: 800px;
  margin: 0 auto 3rem !important;
  color: #7f8c8d;
  line-height: 1.8;
`;

// Scoped styles for carousel arrows
const StyledCarousel = styled(Carousel)`
  .slick-prev,
  .slick-next {
    font-size: 1.2rem; /* Reduce font size */
    z-index: 1;
    color: #906c44;
    position: absolute;
    width: 40px; /* Reduce width */
    height: 40px; /* Reduce height */
    top: 50%;
    transform: translateY(-50%);
    border-radius: 50%;
    background: rgba(192, 160, 128, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.3s ease, color 0.3s ease;
  }

  .slick-prev::before,
  .slick-next::before {
    display: none;
  }

  .slick-prev {
    left: -45px; /* Adjust position */
  }

  .slick-next {
    right: -45px; /* Adjust position */
  }

  .slick-prev:hover,
  .slick-next:hover {
    background: rgba(160, 120, 90, 0.6);
    color: #fff;
  }

  @media (min-width: 1440px) {
    .slick-prev,
    .slick-next {
      width: 35px; /* Further reduce size for larger screens */
      height: 35px;
    }

    .slick-prev {
      left: -40px; /* Adjust position for larger screens */
    }

    .slick-next {
      right: -40px;
    }
  }

  .slick-slide img {
    max-height: 400px; /* Limit the height of carousel images */
    object-fit: cover;
  }

  @media (min-width: 1440px) {
    .slick-slide img {
      max-height: 250px; /* Further reduce image height on larger screens */
    }
  }
`;

const CardTitle2 = styled(Title)`
  font-family: "Playfair Display", serif !important;
  margin-bottom: 0.5rem !important;
  font-size: 1.5rem !important;
  color: #2c3e50 !important;

  &:after {
    content: "";
    display: block;
    width: 50px;
    height: 2px;
    background-color: #c0a080;
    margin-top: 0.5rem;
  }
`;

//
const CardDescription = styled(Paragraph)`
  font-family: "Montserrat", sans-serif;
  color: #7f8c8d;
  font-size: 0.95rem;
  line-height: 1.6;
  margin-top: 1rem !important;
`;

// Updated LuxuryCard with Book Now button
const LuxuryCard = styled(Card)`
  margin: 1rem;
  border-radius: 12px;
  overflow: hidden;
  border: none;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  height: 550px; /* Changed from fixed 550px */
  min-height: 500px; /* Added min-height */
  position: relative;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  }

  .ant-card-cover img {
    height: 280px; /* Reduced from 320px */
    object-fit: cover;
    transition: all 0.5s ease;

    @media (max-width: 992px) {
      height: 240px;
    }
  }

  &:hover .ant-card-cover img {
    transform: scale(1.05);
  }

  .ant-card-body {
    padding: 1.5rem;
    padding-bottom: 3rem; /* Ensure space for the button */
  }
`;

// Book Now Button for Carousel Cards
const BookNowButton = styled(Button)`
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  background-color: #b99028;
  border: none;
  color: white;
  font-size: 14px;
  border-radius: 4px;
  padding: 4px 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  &:hover {
    background-color: #a17c1f;
    color: white;
  }
`;

// Updated Gallery Styled Components
const ModernGallerySection = styled.section`
  min-height: 100vh;
  padding: 5rem 2rem;
  background-color: rgba(255, 255, 255, 0.8); /* Slightly transparent white */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const GalleryContentWrapper = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
`;

const GallerySectionHeading = styled.h2`
  font-family: "Raleway", sans-serif;
  color: white;
  font-size: 36px;
  font-weight: bold;
  margin: 0 0 1rem;
  text-align: center;
`;

const GallerySubheading = styled.p`
  font-family: "Open Sans", sans-serif;
  color: #b3b3b3;
  font-size: 18px;
  text-align: center;
  margin-bottom: 3rem;
`;

const ModernGalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(220px, 1fr)
  ); /* Reduced from 280px */
  grid-auto-rows: 250px; /* Reduced from 300px */
  grid-auto-flow: dense;
  gap: 1.5rem;

  @media (min-width: 1440px) {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    grid-auto-rows: 280px;
  }

  @media (max-width: 992px) {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    grid-auto-rows: 220px;
  }

  @media (min-width: 768px) {
    div:nth-child(4n + 1) {
      grid-column: span 2;
      grid-row: span 1;
    }

    div:nth-child(8n + 2) {
      grid-column: span 1;
      grid-row: span 2;
    }

    div:nth-child(6n + 3) {
      grid-column: span 2;
      grid-row: span 2;
    }
  }
`;
const GalleryImageWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  border-radius: 12px;
  cursor: pointer;
`;

const GalleryImageOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 2;

  ${GalleryImageWrapper}:hover & {
    opacity: 1;
  }
`;

const ViewIcon = styled.div`
  background: rgba(185, 144, 40, 0.8);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: scale(0.8);
  transition: transform 0.3s ease;

  ${GalleryImageWrapper}:hover & {
    transform: scale(1);
  }
`;

const ModernGalleryImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;

  ${GalleryImageWrapper}:hover & {
    transform: scale(1.1);
  }
`;

// Image Viewer Enhancements
const CloseViewerButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1002;
  transition: background 0.3s ease;

  &:hover {
    background: rgba(185, 144, 40, 0.8);
  }
`;

const EnlargedImageContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ImageCounter = styled.div`
  color: white;
  background: rgba(0, 0, 0, 0.6);
  padding: 5px 15px;
  border-radius: 15px;
  position: absolute;
  bottom: -30px;
  font-size: 14px;
`;

// Update the original styled components for the viewer
const EnlargedImage = styled.img`
  max-width: 90vw;
  max-height: 80vh;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
`;

// Scoped styles for gallery arrows
const ArrowButton = styled.button`
  background: rgba(0, 0, 0, 0.5);
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 1rem;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background: rgba(185, 144, 40, 0.8);
  }
`;

const CircularGalleryWrapper = styled(motion.div)`
  height: 500px;
  width: 100%;
  margin-top: 2rem;

  @media (max-width: 768px) {
    height: 350px;
  }
`;

export default GertSibande;
